<template>
  <div class="base-card-list-item">
    <span class="base-card-list-item-label">{{ label }}</span>
    <slot class="base-card-list-item-value"></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseCardItem',

  props: {
    label: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.base-card-list-item {
  width: 50%;
  display: flex;
  margin-top: 10px;
  padding-left: 50px;
  line-height: 28px;

  &-label {
    margin-right: 10px;
    white-space: nowrap;
  }

  &-value {
    word-break: break-all;
  }
}
</style>
